import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { fillArr } from '@pin-up-global/common';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { BotLicense } from './licenses.abstraction';

@Injectable()
export class LicensesApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getLicenses(): Observable<ListResponse<BotLicense>> {
    return of({
      items: fillArr(5, id =>
        ({
          value: `license_${ id }`,
          label: `License ${ id }`,
        }),
      ),
      count: 5,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
